import { supabase } from './supabaseClient.js';

export const getPersonas = async (client = supabase) => {
  const { data, error } = await client
    .from('personas')
    .select('id, rut, nombre, apellido_paterno, apellido_materno, email, telefono, comuna, region, origen, tiene_cuenta, created_at')
    .order('apellido_paterno', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const getPersonaById = async (id, client = supabase) => {
  const { data, error } = await client
    .from('personas')
    .select('*')
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
};

export const getCertificadosByPersonaId = async (personaId, client = supabase) => {
  const { data, error } = await client
    .from('empresa_persona_certificados')
    .select(`
      id,
      estado,
      pagador,
      created_at,
      certificados:certificado_id (
        id, codigo, fecha_emision, fecha_inicio_cobertura, fecha_termino_cobertura, email_enviado
      ),
      empresa_empleadores:empresa_id (
        id, razon_social, nombre_fantasia, rut
      ),
      subscriptions:subscription_id (
        id, codigo, plan_name, status, amount, currency
      )
    `)
    .eq('persona_id', personaId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
};

export const createPersona = async (form, client = supabase) => {
  const { data, error } = await client
    .from('personas')
    .insert([form])
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const updatePersona = async (id, form, client = supabase) => {
  const { data, error } = await client
    .from('personas')
    .update({ ...form, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
};
